import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import FormDrawerWrapper from '../../../../features/components/FormDrawerWrapper'
import EditSectionsList from '../../../../features/components/Forms/EditForm/EditSectionsList'
import NameSection from './Sections/NameSection'
import NameSectionPreview from '../../../ReusableFormSections/NameSection/NameSectionPreview'
// import BudgetSectionPreview from '../../../ReusableFormSections/reusableBudgetSections/Dv360CampaignBudgetSection/BudgetSectionPreview'
// import BudgetSectionForm from '../../../ReusableFormSections/reusableBudgetSections/Dv360CampaignBudgetSection/BudgetSectionForm'
// import DatesSectionForm from './Sections/DatesSection/DatesSectionForm'
// import DatesSectionPreview from './Sections/DatesSection/DatesSectionPreview'

import { clearCampaign, getCampaign } from '../../../../modules/actions/campaigns'
import {
  campaignLoadingSelector,
  campaignSelector,
  campaignWasLoadedSelector
} from '../../../../modules/selectors/campaigns'
import { selectedDV360AdAccountSelector } from '../../../../modules/selectors/adAccounts'

import useManageEditFormData from '../../../../hooks/formHooks/useManageEditFormData'

import { CAMPAIGN_DV360_EDIT } from '../../../../constants/forms'
import { NAME } from '../../../Multiplatform/CampaignForms/fields'
import { DV_360_PLATFORM } from '../../../../constants/selectLists/platformList'

// here defined initial open states for CampaignDv360Edit sections
const sectionsInitialOpenStates = {
  [NAME]: false
  // [CAMPAIGN_DATES]: false,
  // [CAMPAIGN_BUDGET]: false
}

const CampaignDv360Edit = ({ shouldBeCleared }) => {
  const dispatch = useDispatch()

  const campaign = useSelector(campaignSelector)
  const isCampaignLoading = useSelector(campaignLoadingSelector)
  const campaignWasLoaded = useSelector(campaignWasLoadedSelector)
  const { id: selectedAdAccountId } = useSelector(selectedDV360AdAccountSelector)

  const isInitialDataLoading = isCampaignLoading || !campaignWasLoaded

  const getCampaignDataHandler = useCallback(
    selectedEditItemId => {
      // Load campaign data only if user is on campaigns list page
      // if user is on campaign summary page - we already have campaign data in store
      if (!campaign.id) {
        dispatch(getCampaign({ id: selectedEditItemId, account: selectedAdAccountId }, DV_360_PLATFORM))
      }
    },
    [dispatch, selectedAdAccountId, campaign.id]
  )

  const clearCampaignDataHandler = useCallback(() => {
    if (shouldBeCleared) {
      dispatch(clearCampaign())
    }
  }, [dispatch, shouldBeCleared])

  useManageEditFormData({
    formName: CAMPAIGN_DV360_EDIT,
    loadedDataId: campaign.id,
    getDataHandler: getCampaignDataHandler,
    clearDataHandler: clearCampaignDataHandler
  })

  // here defined all edit sections for CampaignDv360Edit
  const editSections = useMemo(
    () => [
      {
        sectionName: NAME,
        title: 'Name',
        PreviewComponent: <NameSectionPreview dataSelector={campaignSelector} />,
        FormComponent: <NameSection />
      }
      // {
      //   sectionName: CAMPAIGN_DATES,
      //   title: 'Dates',
      //   PreviewComponent: <DatesSectionPreview />,
      //   FormComponent: <DatesSectionForm />
      // },
      // {
      //   sectionName: CAMPAIGN_BUDGET,
      //   title: 'Budget',
      //   PreviewComponent: <BudgetSectionPreview campaign={campaign} />,
      //   FormComponent: <BudgetSectionForm adAccountId={selectedAdAccountId} />
      // }
    ],
    []
  )

  return (
    <FormDrawerWrapper title="Edit a DV360 campaign" formName={CAMPAIGN_DV360_EDIT} showOpenButton={false}>
      <EditSectionsList
        editSections={editSections}
        isEditDataLoading={isInitialDataLoading}
        editItemData={campaign}
        sectionsInitialOpenStates={sectionsInitialOpenStates}
      />
    </FormDrawerWrapper>
  )
}

export default CampaignDv360Edit
